<template>

<div>
    <not-allowed v-if="!AllowedDisplay"></not-allowed>

    <div v-else>
        <v-row no-gutters>
            <v-col v-for="tag in tags" :key="tag" >
                <v-checkbox
                :value="tag"
                v-model="selectedTags"
                hide-details
                >
                <template v-slot:label>
                    <div style="display: flex; align-items: center;">
                    <img
                        :src="iconByTag[tag]"
                        style="width: 20px; height: 20px; margin-right: 8px;"
                    />
                    <span>{{ tag }}</span>
                    </div>
                </template>
                </v-checkbox>
            </v-col>
        </v-row>


            <l-map
                class="leaflet-map"
                :zoom="datas.zoom"
                ref="map"
                :key="mapKey"
                style="height: 500px; width: 100%;"
            >
                <!-- Fond de carte -->
                <l-tile-layer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution="&copy; OpenStreetMap"
                />

                <!-- Points -->
                <l-marker
                v-for="point in datas.points.filter(p => selectedTags.includes(p.tag))"
                :key="point.id"
                :lat-lng="[point.lat, point.lng]"
                :icon="getIcon(point)"
                @click="onMarkerClick(point)"
                @mouseover="hovered = point.id"
                @mouseout="hovered = null"
                >
                <!-- Tooltip (hover) -->
                <l-tooltip direction="top" :options="{ permanent: false }">
                    {{ point.tooltipcontent }}
                </l-tooltip>

                <!-- Popup (clic) -->
                <l-popup>

                        <h3>{{ point.tooltipcontent }}</h3>
                    <div v-html="point.popupcontent"></div>
                            <v-btn @click="openDetails(point)" v-if="datas.encarts[point.tag].length">
                                détail
                            </v-btn>
                            <v-btn v-for="(action,i) in point.actions" :key="i" @click="callAction(action,point)">
                                <v-icon v-show="action.icon">{{action.icon}}</v-icon>
                                {{action.name}}
                            </v-btn>

                </l-popup>
                </l-marker>
            </l-map>
    
        <v-dialog
          v-model="dialog"
          v-if="selectedTag"
          :fullscreen="($vuetify.breakpoint.xs) ? true : false"
          @click:outside="closeDetails"
          width="50%"
        >
            <v-card>
        <v-card-title >
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDetails"><v-icon>mdi-close-thick</v-icon></v-btn>      
        </v-card-title>
                <v-card-text>
                    <CPage
                        :key="selectedTag.id"
                        :pageTemplate="datas.encarts[selectedTag.tag]"
                        :customparams="selectedTag"
                        :page="page"
                        :modal="modal"
                        :modalKey="modalKey"
                        :form="false"
                        :hook="hook"
                        :mod="false"
                        />    
                </v-card-text>
                <v-card-actions>
                    <span v-for="(action,i) in selectedTag.actions" :key="'a'+i" class="d-inline-flex align-center">
                    <v-btn @click="callAction(action,point)">
                        <v-icon >{{action.icon}}</v-icon>
                        {{action.name}}
                    </v-btn>
                    <rights-indicator :checks="actionInspectionChecks(action)" :label="action.name" />
                    </span>
                </v-card-actions>
            </v-card>    
    </v-dialog>    
    
    
        </div>

</div>

</template>



<script>

import { LMap, LTileLayer, LMarker, LPopup, LTooltip } from 'vue2-leaflet'

import { client } from '../mixins';
import L from 'leaflet'

    export default {

    name :'DMapModule',

    mixins : [client],

    components: {
        LMap,
        LTileLayer,
        LMarker,
        LPopup,
        LTooltip,
    },

        data: function() {

            return {
                show : false,
                AllowedDisplay : true,
                datas : {points : [],zoom: 6},
                selectedTags: [],
                mapKey : 0,
                searchmodule : [],
                dialog:  false,
                selectedTag : false,
                fromThisModule : false,
            }
        },

        computed: {
            tags() {
            // liste unique des tags
            const unique = new Set(this.datas.points.map((p) => p.tag));
            return Array.from(unique);
            },
            //permet de créer l'array pour définir quelle icone va avec quel tag
            iconByTag() {
                const map = {};

                this.datas.points.forEach(p => {
                // si plusieurs points ont le même tag,
                // on garde la première icône rencontrée
                if (!map[p.tag]) {
                    map[p.tag] = p.iconurl;
                }
                });

                return map;
            }
        },

        watch : {
        
            showMod: {
            // permet de rafraichir quand la modal de la page se ferme
            handler(val) {
                if (val.show === false && this.fromThisModule) {
                    this.callAPI(true)
                    this.fromThisModule = false;
                }
            },
            deep: true,
            },

            '$route.query'(val, oldVal) {
            const keys = new Set([...Object.keys(val || {}), ...Object.keys(oldVal || {})]);
            if ([...keys].some(key => this.searchmodule.some(id => key.startsWith(id + '_'))
                && JSON.stringify(val[key]) !== JSON.stringify((oldVal || {})[key]))) this.callAPI();
            },

        },

        methods :  {

            callAPI(oncloseWindow) {
                this.API({type:'post', url:'displaymodule', params:{id:this.idmodule,params:this.params,querys:this.$route.query}}).then((resp) => {
                        this.manageDatas(resp.data,oncloseWindow)              
                })

            },

            manageDatas(datas,oncloseWindow) {
                if(!datas.success) {
                        this.AllowedDisplay = false;
                        this.$emit('isloaded',{mod:this.idmodule,'resp':true}); 
                        return false;
                        }
                    this.datas = datas
                    this.searchmodule = datas.search;
                    if(!oncloseWindow) {
                        this.fitMapToPoints();
                        this.selectedTags = this.tags.slice();
                    }
                    
                    this.show = true 
            },

            //pourt centrer automatiquement la carte sur les points affichés
            fitMapToPoints () {
                if (!this.datas.points.length) return

                const bounds = L.latLngBounds(
                this.datas.points.map(p => [p.lat, p.lng])
                )

                this.$refs.map.mapObject.fitBounds(bounds, {
                padding: [30, 30]
                })
            },            

            onMarkerClick () {
            //console.log('Marker cliqué :', point)
            },

            openDetails (point) {
                this.selectedTag = point;
                this.dialog = true;
            },

            closeDetails () {
                this.selectedTag = false;
                this.dialog = false;
            },

            getIcon (point) {

            return L.icon({
                iconUrl: point.iconurl,
                iconSize: [point.iconwidth, point.iconheight],
                iconAnchor: [12, 41],
                popupAnchor: [1, -34]
            })
            },


        callAction(action,point) {
                this.clickActions({args:point,action:action,idmodule:this.idmodule,modalKey:this.modalKey,page:this.page,selectedLines:false,
                success:(datas) => {
                    if(datas.message) this.$toast.success(datas.message);
                },
                whenlink:() => {
                    this.fromThisModule = true;
                }
                })
        },

        },

        mounted() {


                this.params = this.$store.getters.specificPage(this.modalKey).params
                if(this.customparams) this.params = this.customparams

            let getdatas = this.$store.getters.getModuleDatas({page:this.modalKey,id:this.idmodule});
                if(getdatas) {
                    this.manageDatas(getdatas.datas)
                    this.$store.dispatch('removeModuleDatas',{page:this.modalKey,id:this.idmodule})
                } else {
                    this.callAPI() 
                } 
        }

    }

</script>

<style scoped>
.leaflet-map {
  position: relative;
  z-index: 1;
}
</style>
